var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeadline)?_c('h3',{staticClass:"text-xl leading-6 font-medium"},[_vm._v(_vm._s(_vm.headline))]):_vm._e(),_vm._v(" "),_c('dl',{staticClass:"mt-5 tile stats",class:{
        'flex flex-row justify-start lg:justify-between bg-white overflow-hidden divide-gray-200 md:divide-y-0 md:divide-x': !_vm.showGrid,
        'gap-0 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5': _vm.showGrid && _vm.gridCols === 5,
        'gap-0 grid grid-cols-1 xs:grid-cols-2 xl:grid-cols-4': _vm.showGrid && _vm.gridCols === 4}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }